export const LOAD_STATE = 'LOAD_STATE';
export const LOAD_CHART_STATE = 'LOAD_CHART_STATE';
export const APPEND_REPORT_DATA = 'APPEND_REPORT_DATA';
export const SET_FILTER = 'SET_FILTER';
export const TOGGLE_SECTION = 'TOGGLE_SECTION';
export const TOGGLE_COLLAPSE_ALL_ROWS = 'TOGGLE_COLLAPSE_ALL_ROWS';
export const RESET_COLLAPSE_ALL_ROWS = 'RESET_COLLAPSE_ALL_ROWS';
export const SET_LOADING = 'SET_LOADING';
export const SET_LOADING_MORE = 'SET_LOADING_MORE';
export const SET_ORGANIZATION = 'SET_ORGANIZATION';
export const UPDATE_PREVIOUS_VIEW = 'UPDATE_PREVIOUS_VIEW';
export const SET_PREVIOUS_REPORT_QUERY = 'SET_PREVIOUS_REPORT_QUERY';
export const UPDATE_PREVIOUS_REPORT_QUERY = 'UPDATE_PREVIOUS_REPORT_QUERY';
export const UPDATE_PREVIOUS_WALKER = 'UPDATE_PREVIOUS_WALKER';
export const APPEND_SAVED_REPORT_FILTER = 'APPEND_SAVED_REPORT_FILTER';
export const UPDATE_SAVED_REPORT_FILTER = 'UPDATE_SAVED_REPORT_FILTER';
export const DELETE_SAVED_REPORT_FILTER = 'DELETE_SAVED_REPORT_FILTER';
export const SET_APPLYING_SAVED_REPORT_FILTER = 'SET_APPLYING_SAVED_REPORT_FILTER';
export const SET_QUEUE_TYPE = 'SET_QUEUE_TYPE';
export const SET_SCHEDULE_REPORT_TOAST = 'SET_SCHEDULE_REPORT_TOAST';
export const SET_SCHEDULE_REPORT_TOAST_CLICK_SOURCE = 'SET_SCHEDULE_REPORT_TOAST_CLICK_SOURCE';
export const SET_CAN_SHOW_SCHEDULE_REPORT_TOAST = 'SET_CAN_SHOW_SCHEDULE_REPORT_TOAST';
export const SET_INTERNAL_ERROR = 'SET_INTERNAL_ERROR';
